import { restClient } from '@/Core'

export interface CreateShiftBatchPayload {
    /** Перша дата періоду, РРРР-ММ-ДД */
    dateFrom: string
    /** Остання дата періоду (включно), РРРР-ММ-ДД */
    dateTo: string
    /** IRI кластера й регіону — спільні для всіх змін */
    cluster: string
    region: string
    /** Пари «водій + ТЗ» (IRI); кожна отримує зміну на кожну дату періоду */
    rows: { driver: string; vehicle: string }[]
}

/**
 * Множинне створення змін одним запитом (ShiftBatchController): усе або нічого —
 * якщо хоч одна зміна вже існує, бекенд повертає 422 з переліком конфліктів.
 */
export const CreateShiftBatchTask = async (payload: CreateShiftBatchPayload): Promise<any> => {
    return restClient.post('/services/shifts/batch', { json: payload })
}
